import {useMutation, UseMutationResult, useQuery, UseQueryResult, useQueryClient} from '@tanstack/react-query';
import {adminsApi} from '../api';
import {AdminsFilter, AdminWithMetaModel, CreateAdminDTO} from '../model';
import {useCallback, useState} from 'react';
import { useNotifications } from '../../../shared';


type AdminsState = {
  getAdmins: UseQueryResult<AdminWithMetaModel, Error>;
  filters: AdminsFilter;
  updateFilter: (newFilter: Partial<AdminsFilter>) => void;
  createAdminMutation: UseMutationResult<unknown, Error, CreateAdminDTO>;
};

export const useAdmins = (initialFilter: AdminsFilter = {}): AdminsState => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();
  const [filters, setFilters] = useState<AdminsFilter>({
    page: 1,
    pageSize: 50,
    ...initialFilter,
  });

  const getAdmins = useQuery<AdminWithMetaModel, Error>({
    queryKey: ['admins'],
    queryFn: () => adminsApi.getAdmins(filters),
  });

  const updateFilter = useCallback((newFilter: Partial<AdminsFilter>) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilter,
      ...(!newFilter.page && !newFilter.pageSize ? {page: 1} : {}),
    }));
  }, []);

  const createAdminMutation = useMutation({
    mutationFn: adminsApi.createAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['admins']});
      createNotification({
        title: 'Админ успешно создан',
        name: 'createAdmin',
        theme: 'success',
      });
    },
  });

  return {
    getAdmins,
    filters,
    updateFilter,
    createAdminMutation,
  };
};
